<template>
  <div class="flex flex-col items-center p-4 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
        class="rounded-3xl flex flex-col justify-center items-center bg-NAVY-BLUE relative px-4 pb-4 pt-2 h-[140px] w-[140px]"
      >
        <font-awesome-icon size="2xl" icon="fa-solid fa-check" />
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">NFT Bought Succesfuly</p>
        <p class="text-sm font-normal pt-3">
          You’ve completed <strong>Buy NFT</strong> Will be check in list card collection.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-6 pt-3 items-center w-full pb-3">
      <div class="w-full px-4">
        <div class="relative flex flex-row gap-4 p-3 bg-PRIMARY rounded-md items-center w-full">
          <div class="w-[60px] h-[60px] bg-LIGHTGREY rounded-md flex justify-center items-center">
            <img src="@/assets/images/empty-img.svg" class="w-4 h-5 object-contain" />
          </div>
          <div class="flex flex-col gap-2">
            <p class="text-sm font-semibold">Puma Collection</p>
            <div class="flex flex-row gap-2 justify-start items-center">
              <img src="@/assets/icons/token-2.svg" class="h-4 object-contain" />
              <p class="text-xs">200</p>
              <div class="rounded-full w-1 h-1 bg-WHITE"></div>
              <p class="text-xs">QTY 2</p>
            </div>
          </div>
          <div
            class="absolute right-2 top-2 rounded-md bg-LIGHTGREY border border-1 border-WHITE py-0.5 px-1"
          >
            <p class="text-PRIMARY text-xs min-w-6 font-semibold">SSR</p>
          </div>
        </div>
      </div>

      <pow-button quaternary class="w-full" :loading="loading">
        <p class="text-BLACK font-normal text-sm">Go to Collection</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import PowButton from '@/components/PowButton.vue'
import PirateFigure from '../PirateFigure.vue'
import { ref } from 'vue'

const props = defineProps({
  pirateInfo: {
    type: Object,
    required: true
  }
})
const loading = ref(false)
</script>
